const styles = {
  container: 'w-[4.5rem]',
  trigger: '!text-xs font-semibold border-none ring-none ',
  item: 'text-sm  cursor-pointer hover:!bg-primary-100',
};

export default styles;
